import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        bold: {
            fontWeight: 700,
        },
        container: {
            alignItems: 'flex-start',
        },
        text: {
            '& ul': {
                margin: theme.spacing(0.5, 0),
            },
            lineHeight: theme.spacing(2.2),
        },
    }
})

export default useStyles
